//3rd party imports
import React, { useEffect, useState } from "react";

//Local imports
import { ITemplateItem } from "modules/Campaigns/interfaces";
import { STATIC_TEMPLATES_IMAGE_URL } from "./../../../../../constants/index";
import ButtonRightIconGreen from "../../../../Common/Components/ButtonRightIconGreen";
import Eye from "../../../../../assets/img/icons/EyeWhite.svg";
import Tick from "../../../../../assets/img/icons/tick-white.svg";

//Style imports
import styled from "styled-components";

type TemplateCardProps = {
  selectedTemplateId?: any;
  template: ITemplateItem;
  selectTemplate: (id: number, name: string, image: string) => void;
  setShowPreview: (value: number) => void;
  clearAllSelection: () => void;
};

const TemplateCard: React.FC<TemplateCardProps> = (props: TemplateCardProps) => {
  const { selectedTemplateId, template, selectTemplate, setShowPreview, clearAllSelection } = props;
  const [toggleSelected, setToggleSelected] = useState(false);

  const setSelectedTemplateAttributes = (id: number) => {
    // Set selected class when user clicks and template
    clearAllSelection();
    document.querySelectorAll(".template-card").forEach(function (item) {
      if (item.classList.contains("selected")) {
        item.classList.remove("selected");
      }
    });
    let elem = document.querySelectorAll('[data-attr-id="' + id.toString() + '"]');
    if (elem.length > 0) {
      // if (elem[0].classList.contains("selected")) {
      //   setToggleSelected(false);
      //   elem[0].classList.remove("selected");
      //   selectTemplate(0, "", "");
      // } else {
      setToggleSelected(true);
      elem[0].classList.add("selected");
      selectTemplate(template.id, template.name, STATIC_TEMPLATES_IMAGE_URL + template.thumbnail);
      // }
    }
  };

  useEffect(() => {
    if (template.id === selectedTemplateId) {
      setToggleSelected(true);
    }
  });

  return (
    <Wrapper
      key={template.id}
      data-attr-id={template.id}
      className={`template-card ${toggleSelected === true ? " selected " : ""}`}
      data-template="data-template"
    >
      <div
        onClick={() => {
          setSelectedTemplateAttributes(template.id);
        }}
        data-template-inner="data-template-inner"
      >
        <div className="overlay-selected" onClick={() => setToggleSelected(false)}>
          <img src={Tick} className={`${toggleSelected === true ? " selected " : ""}`}/>
        </div>
        <div className="thumb">
          <img src={STATIC_TEMPLATES_IMAGE_URL + template.thumbnail} />
        </div>
        <div>
          <span className="template-name">{template.name}</span>
        </div>
      </div>
      <div className="overlay">
        <ButtonRightIconGreen onClick={() => setShowPreview(template.id)} icon={Eye} label="Preview" />
      </div>
    </Wrapper>
  );
};

export default TemplateCard;

const Wrapper = styled.div`
  width: 100%;
  margin: 10px 0;
  cursor: pointer;
  position: relative;
  .thumb {
    width: 100%;
    height: 130px;
    overflow: hidden;
    box-shadow: 0px 0px 17px -2px rgb(0 0 0 / 8%);
    img {
      width: 100%;
    }
  }

  span.template-name {
    color: #424b50;
    font-size: 14px;
    font-weight: 600;
    font-family: "Roboto Slab", serif;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 10px;
    margin-top: 7px;
    width: 100%;
    min-height: 46px;
    -webkit-box-align: start;
    transition-duration: 0.5s;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      line-height: 12px;
      font-size: 10px;
      margin-top: 5px;
      min-height: 24px;
    }
  }
  .overlay {
    opacity: 0;
    visibility: hidden;
    transition-duration: 0.5s;
    position: absolute;
    top: 50px;
    left: 50%;
    height: 40px;
    width: 0px;
    /* width: 100%; */
    button {
      transform: translate(-50%, -50%);
      top: 50%;
      position: absolute;
      left: 50%;
      padding-left: 6px;
      .label {
        color: #fff;
        margin-right: 5px;
        width: auto;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
        }
      }
      .icon {
        padding: 1px 3px;
        align-items: normal;
        width: auto;
        img {
          max-width: 17px;
        }
      }
    }
  }
  .overlay-selected {
    opacity: 0;
    visibility: hidden;
    transition-duration: 0.5s;
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #27ce0a;
    padding: 0 7px 2px 7px;
    border-radius: 3px;
  }

  &:hover {
    .overlay {
      opacity: 1;
      visibility: visible;
    }
  }
  &.selected {
    .overlay-selected {
      opacity: 1;
      visibility: visible;
    }
  }
`;
